import { nonNullableValue } from '~shared/lib/non-nullable-value/non-nullable-value';

import type { UseQueryOptions } from '@tanstack/react-query';
import { keepPreviousData, useMutation } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';

import {
  findApplications,
  getApplicationById,
  generateApplicationsReport,
} from './gateway-applications-api';

import type { Application } from '../model/application';
import type { FindApplicationsRequestParams } from '../model/find-applications-params';

export const useFindApplicationsQuery = (
  requestOptions: FindApplicationsRequestParams,
  options: Omit<
    UseQueryOptions<{
      applications: Application[];
      total: number;
    }>,
    'queryKey' | 'queryFn'
  > = {}
) => {
  return useQuery({
    ...options,
    queryKey: ['find-applications', requestOptions],
    queryFn: async () => {
      const { items, pageInfo } = await findApplications(requestOptions);

      return {
        applications: items,
        total: pageInfo.total,
      };
    },
    placeholderData: keepPreviousData,
  });
};

export const useGetApplicationByIdQuery = (applicationId?: string | null) => {
  return useQuery({
    queryKey: ['get-application', applicationId],
    queryFn: async () => getApplicationById(nonNullableValue(applicationId)),
    enabled: !!applicationId,
  });
};

export const useGenerateReportMutation = () => {
  return useMutation({
    mutationKey: ['generate-report'],
    mutationFn: async (requestParams: FindApplicationsRequestParams) =>
      generateApplicationsReport(requestParams),
  });
};
